import React from "react";
import x1921 from "../../images/x1921.png";
import fitr from "../../images/fitr.png";
import arrow from "../../images/arrow.png"

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <section className="relative bg-[#F8F8F8] py-12 md:py-16">
        <div className="container mx-auto">

          {/* 4-column grid */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            
            {/* Column 1 – spans 2 columns */}
            <div className="space-y-4 md:col-span-2">

            <img src={x1921} alt="Merakzy Logo" className="w-40 h-auto cursor-pointer" />

              <div className="text-md text-black-700">
                <p>contact@merakzy.com | +389 70 952 828</p>
              </div>

              <div className="text-md text-black-700 flex pt-4 items-center gap-2">
                <span>Проектот е поддржан од</span>
                <img
                  src={fitr}
                  alt="Fitr Logo"
                  className="w-[92px] h-auto cursor-pointer"
                />
              </div>
            </div>

            {/* Column 2 – 1 column */}
            <div className="space-y-3 text-lg font-bold">
              <a href="/about" className=" block hover:opacity-70">За нас</a>
              <a href="/blog" className="block hover:opacity-70">Блог</a>
              <a href="/tutorials" className="block hover:opacity-70">Tуторијали</a>
              <a href="/contact" className="block hover:opacity-70">Контакт</a>
              <a href="/privacy-policy.html" className="block hover:opacity-70">Политика на приватност</a>              
            </div>

            {/* Column 3 – 1 column */}
            <div className="space-y-5 text-lg font-bold">
              {[
                { label: "Facebook", link: "#" },
                { label: "Instagram", link: "#" },
                { label: "LinkedIn", link: "#" },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.link}
                  className="flex items-center justify-between border-b border-gray-300 pb-2 hover:opacity-70"
                >
                  <span>{item.label}</span>
                  <span><img
                  src={arrow}
                  alt="arrow"
                  className="w-6 h-auto cursor-pointer"
                /></span>
                </a>
              ))}
            </div>

          </div>
        </div>
      </section>
      <footer className="bg-white py-6 text-center text-gray-800 font-semibold text-sm">
        © {currentYear} Merakzy. All rights reserved.
      </footer>
    </>
  );
};

export default Footer;



